import React, { useState, useRef, useLayoutEffect } from 'react';
import {IconControl} from 'spark-core-dx/components';

const UpdatedInfoControl = ({ children }) => {
    const [openInfoMenu, setOpenInfoMenu] = useState(false);
    const menuRef = useRef(null);

    useLayoutEffect(() => {
        if (openInfoMenu && menuRef.current) {
            const menu = menuRef.current;
            menu.classList.remove('overflow-right', 'overflow-left', 'overflow-bottom');
            const rect = menu.getBoundingClientRect();

            const navbar = document.querySelector('.side-navbar');
            if (!navbar) return;

            const navbarRect = navbar.getBoundingClientRect();

            const footerHeight = 42; // 3rem
            const headerHeight = 56; // 4rem
            const infoMenuAdjustment = 35; // 2.5rem
            const navbarPadding = navbarRect.width;

            // Since .core-screen has padding-left: var(--sideNavWidth), 
            // the info-menu's left position already includes that padding.
            // And then we want to check if the menu is overflowing into the padded navbar area.
            if ((rect.left - navbarPadding) < navbarPadding) menu.classList.add('overflow-left');
            if (rect.right + navbarPadding > window.innerWidth) menu.classList.add('overflow-right');
            if (rect.bottom > window.innerHeight - footerHeight - headerHeight - infoMenuAdjustment) menu.classList.add('overflow-bottom');
        }
    }, [openInfoMenu]);

    return (
        <div
            className="info-icon-wrapper"
            onMouseOver={() => setOpenInfoMenu(true)}
            onMouseLeave={() => setOpenInfoMenu(false)}
        >
            <IconControl iconKey={'info'} />
            {openInfoMenu && (
                <div className="info-menu" ref={menuRef}>
                    {children}
                </div>
            )}
        </div>
    );
};

export default UpdatedInfoControl;
